// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import textColorStyles from '../../../styles/atoms/text-color.module.css'
import {
  IconProps,
  computeStrokeWidth,
  computeSize,
  IconComponentRef,
} from '../helpers'
const LinkShorteningOffIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'link-shortening-off'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(
          className,
          styles.base,
          color && textColorStyles[color],
        )}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M10 12.6053C10.3236 13.0046 10.7365 13.3351 11.2106 13.5742C11.6847 13.8133 12.209 13.9555 12.7479 13.9911C13.2868 14.0267 13.8277 13.955 14.3339 13.7807C14.8401 13.6064 15.2998 13.3336 15.6817 12.9809L17.9424 10.8941C18.6287 10.2382 19.0084 9.35963 18.9999 8.44773C18.9913 7.53582 18.595 6.66351 17.8965 6.01867C17.1979 5.37383 16.2529 5.00806 15.265 5.00013C14.2771 4.99221 13.3254 5.34277 12.6148 5.9763L11.3187 7.16576M14 11.3947C13.6764 10.9954 13.2635 10.6649 12.7894 10.4258C12.3153 10.1867 11.791 10.0445 11.2521 10.0089C10.7132 9.97326 10.1723 10.045 9.66611 10.2193C9.15991 10.3936 8.70024 10.6664 8.31828 11.0191L6.05764 13.1059C5.37132 13.7618 4.99156 14.6404 5.00014 15.5523C5.00873 16.4642 5.40497 17.3365 6.10354 17.9813C6.80211 18.6262 7.7471 18.9919 8.73498 18.9999C9.72287 19.0078 10.6746 18.6572 11.3852 18.0237L12.6738 16.8342M1.99219 6L1.99219 2M1.99219 2L5.99219 2M1.99219 2L5.99219 6M21.9922 18V22M21.9922 22H17.9922M21.9922 22L17.9922 18"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)
LinkShorteningOffIcon.displayName = 'LinkShorteningOffIcon'
export { LinkShorteningOffIcon }
